import {Injectable} from '@angular/core';

import {inspirations} from '../../data/inspirations/inspirations.manifest.json';

@Injectable({
    providedIn: 'root'
})
export class InspirationRepository {

    private allInspirations: any[] = null;

    public all(): any[] {
        if (!this.allInspirations) {
            this.allInspirations = inspirations
                .map(inspiration => {
                    return {
                        id: inspiration.id,
                        tag: inspiration.tag,
                        title: inspiration.title,
                        previewPath: `/assets/inspirations/${inspiration.previewFilename}`,
                        headerPath: `/assets/inspirations/${inspiration.headerFilename}`,
                        content: inspiration.content.map(row => {
                            if (row.type === 'image') {
                                return {
                                    type: 'image',
                                    imagePath: `/assets/inspirations/${row.imageFilename}`
                                };
                            }

                            return row;
                        })
                    };
                });
        }

        return this.allInspirations;
    }

    public getByIdOrFirst(id): any {
        return this.all().find(inspiration => +inspiration.id === +id) ?? this.all()[0];
    }
}
